export const markdown_faq_39_1 = `
Ogni account INBEE ha un codice univoco per la configurazione dei dispositivi mobili all'accesso a due fattori.

Nel caso in cui si abbia la necessità di dissociare il proprio account INBEE dai dispositivi precedentemente associati o si abbia la necessità di avere un nuovo codice di configurazione si deve procedere al reset dell'attuale codice di configurazione. 

ATTENZIONE! Resettando il codice di configurazione tutti i dispositivi precedentemente associati saranno dissociati.

1. Accedi all'*area personale*.
2. Seleziona *Reset MFA*.

Al successivo accesso ad INBEE verrà generato il nuovo codice di configurazione per l'associazione dei nuovi dispositivi.
`;
